import SectionHeading from "components/common/SectionHeading";
import ScrollReveal from "components/common/ScrollReveal";
import AWSLogo from "assets/images/AWS.png";
import AzureLogo from "assets/images/Azure.png";
import GoogleLogo from "assets/images/Google_Cloud.png";
import KubernetesLogo from "assets/images/kubernetes-logo-transparent.png";
import MicrosoftLogo from "assets/images/Microsoft.png";
import VeritasLogo from "assets/images/Veritas.png";
import DellLogo from "assets/images/Dell_Logo.png";
import HpeLogo from "assets/images/Hewlett_Packard_Enterprise_logo.png";
import NutanixLogo from "assets/images/Nutanix_Logo.png";
import VmwareLogo from "assets/images/vmware-logo.png";
import CohesityLogo from "assets/images/Cohesity_logo.png";
import ArciteraLogo from "assets/images/arctera-logo.png";
import MS365Logo from "assets/images/MS365.png";
import GoogleWSLogo from "assets/images/GoogleWS.png";
import WebexLogo from "assets/images/WebEx.png";
import ZoomLogo from "assets/images/Zoom.png";
import SapLogo from "assets/images/SAP_2011_logo.png";
import AutomationAnywhereLogo from "assets/images/AutomationAnywhere.png";
import UiPathLogo from "assets/images/UiPath.png";
import AnsibleLogo from "assets/images/Ansible_logo.png";

const EXPERTISE_SECTIONS = [
    {
        title: "Cloud Solutions",
        logos: [
            { src: AWSLogo, alt: "Amazon Web Services" },
            { src: AzureLogo, alt: "Microsoft Azure" },
            { src: GoogleLogo, alt: "Google Cloud" },
            { src: KubernetesLogo, alt: "Kubernetes" },
        ],
    },
    {
        title: "Infrastucture & Migrations",
        logos: [
            { src: MicrosoftLogo, alt: "Microsoft" },
            { src: VeritasLogo, alt: "Veritas" },
            { src: DellLogo, alt: "Dell" },
            { src: HpeLogo, alt: "Hewlett Packard Enterprise" },
            { src: NutanixLogo, alt: "Nutanix" },
            { src: VmwareLogo, alt: "VMware" },
            { src: CohesityLogo, alt: "Cohesity" },
            { src: ArciteraLogo, alt: "Arcitera" },
        ],
    },
    {
        title: "Modern Workspace",
        logos: [
            { src: MS365Logo, alt: "Microsoft 365" },
            { src: GoogleWSLogo, alt: "Google Workspace" },
            { src: WebexLogo, alt: "WebEx" },
            { src: ZoomLogo, alt: "Zoom" },
            { src: SapLogo, alt: "SAP" },
        ],
    },
    {
        title: "Automation",
        logos: [
            { src: AutomationAnywhereLogo, alt: "Automation Anywhere" },
            { src: UiPathLogo, alt: "UiPath" },
            { src: AnsibleLogo, alt: "Ansible" },
        ],
    },
];

const LogoScroller = ({ logos }) => {
    const loopLogos = [...logos, ...logos];
    const duration = Math.max(logos.length * 3.5, 14);

    return (
        <div className="expertise-logo-scroller">
            <div
                className="expertise-logo-track"
                style={{ "--scroll-duration": `${duration}s` }}
            >
                {loopLogos.map((logo, index) => (
                    <div
                        key={`${logo.alt}-${index}`}
                        className="expertise-logo-item"
                    >
                        <img
                            src={logo.src}
                            alt={logo.alt}
                            draggable={false}
                            onDragStart={(event) => event.preventDefault()}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

const OurExpertise = () => {
    return (
        <section className="polygon-bg">
            <style>{`
                .expertise .expertise-logo-scroller {
                    --expertise-scroll-width: 40rem;
                    overflow: hidden;
                    flex-wrap: nowrap !important;
                    justify-content: flex-start !important;
                    width: 100%;
                    max-width: var(--expertise-scroll-width);
                    margin-left: auto;
                    margin-right: auto;
                    mask-image: linear-gradient(
                        to right,
                        transparent,
                        black 10%,
                        black 90%,
                        transparent
                    );
                    -webkit-mask-image: linear-gradient(
                        to right,
                        transparent,
                        black 10%,
                        black 90%,
                        transparent
                    );
                }

                .expertise .expertise-logo-track {
                    display: flex;
                    align-items: center;
                    gap: 2.5rem;
                    width: max-content;
                    animation: expertiseLogoScroll var(--scroll-duration, 24s) linear infinite;
                    will-change: transform;
                }

                .expertise .expertise-logo-scroller:hover .expertise-logo-track {
                    animation-play-state: paused;
                }

                @keyframes expertiseLogoScroll {
                    from {
                        transform: translate3d(0, 0, 0);
                    }
                    to {
                        transform: translate3d(-50%, 0, 0);
                    }
                }

                @media (prefers-reduced-motion: reduce) {
                    .expertise .expertise-logo-track {
                        animation: none;
                        transform: none;
                    }
                }

                .expertise .expertise-logo-item {
                    flex: 0 0 13rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .expertise .expertise-logo-item img {
                    height: 72px;
                    width: auto;
                    max-width: 100%;
                    object-fit: contain;
                    flex-shrink: 0;
                    transition: transform 0.3s ease, opacity 0.3s ease, filter 0.3s ease;
                }

                .expertise .expertise-logo-item img:hover {
                    transform: scale(1.12);
                    opacity: 0.85;
                    filter: drop-shadow(0 8px 16px rgba(219, 50, 54, 0.25));
                }
            `}</style>
            <div className="container">
                <SectionHeading
                    eyebrow="Technology Partners"
                    title="Our Expertise"
                    description="We work with industry-leading platforms to deliver best-in-class solutions across cloud, infrastructure, workspace, and automation."
                />
                {EXPERTISE_SECTIONS.map((section, index) => (
                    <ScrollReveal key={section.title} variant="up" delay={index * 100}>
                        <div className="expertise text-center">
                            <h3>{section.title}</h3>
                            <LogoScroller logos={section.logos} />
                        </div>
                    </ScrollReveal>
                ))}
            </div>
        </section>
    );
};

export default OurExpertise;
